<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import SiteFormPage from '@/views/apps/sites/SiteFormPage.vue'

const sitesPageMeta = PageMeta.Sites as unknown as {
  Edit: { Meta: Record<string, unknown>; Title: string }
}

definePage({ meta: PageMeta.Sites.Edit.Meta })
setPageTitle(sitesPageMeta.Edit.Title)

const route = useRoute()

const siteGuid = computed(() => {
  const params = route.params as Record<string, string | string[] | undefined>
  const guid = params.guid

  return Array.isArray(guid) ? guid[0] : guid
})
</script>

<template>
  <SiteFormPage
    v-if="siteGuid"
    mode="edit"
    :site-guid="siteGuid"
  />
</template>
